module.exports = "fragment MembershipInviteFragment on MembershipInvite {\n  __typename\n  organizationName\n  organizationOwnerName\n  createdAt\n}\n"